import React from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { Button, LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { courseApiSlice } from '../../../features/course/courseSlice'
import CoursesTable from './components/CoursesTable'

const CoursesPage = () => {
    const { formatMessage } = useIntl()
    const { data: courses = [], isFetching } =
        courseApiSlice.useFetchAllCoursesQuery()
    const [deleteCourse, { isLoading: isDeleting }] =
        courseApiSlice.useDeleteCourseMutation()
    const [duplicateCourse, { isLoading: isDuplicating }] =
        courseApiSlice.useDuplicateCourseMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteCourse(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {}
    }

    const handleDuplicate = async (id: number) => {
        try {
            await duplicateCourse(id).unwrap()
            toast.success(formatMessage({ id: 'duplicate' }))
        } catch (e) {}
    }

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'courses' })}</H3>
                    </Title>

                    <Link to="new">
                        <Button variant={'contained'}>
                            {formatMessage({ id: 'addCourse' })}
                        </Button>
                    </Link>
                </Header>

                {(isDeleting || isDuplicating || isFetching) && <LinearProgress />}

                {courses && (
                    <CoursesTable
                        coursesData={courses}
                        onDelete={handleDelete}
                        onDuplicate={handleDuplicate}
                    />
                )}
            </Content>
        </Wrapper>
    )
}

export default CoursesPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
